import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RouterModule } from '@angular/router';
import { MoviesTableComponent } from "../movies-table/movies-table.component";
@Component({
  selector: 'app-admin-movies',
  imports: [RouterModule],
  templateUrl: './admin-movies.component.html',
  styles: ``
})
export class AdminMoviesComponent {

}
